<template>
  <div class="rate">
    <el-rate
      v-if="control.optionStyle === '星星'"
      :value="value || 0"
      :disabled="disabled"
      :max="control.level"
      :colors="starColors"
      @change="emitVal"
      :class="'level-' + control.level"
      key="star"
    ></el-rate>
    <el-rate
      v-else
      :value="value || 0"
      :disabled="disabled"
      :max="control.level"
      :icon-classes="satisfyIcons"
      void-icon-class="custom-icon-rate-face-off"
      disabled-void-icon-class="custom-icon-rate-face-off"
      :colors="satisfyColors"
      :low-threshold="control.level === 5 ? 2 : 5"
      :high-threshold="control.level === 5 ? 4 : 7"
      @change="emitVal"
      class="satisfy"
      :class="'level-' + control.level"
      key="satisfy"
    ></el-rate>
    <div class="rate-text" :class="rateTextClass">
      {{ (value || 0) + unit }}
    </div>
    <div v-if="value && !disabled" class="clear" @click="clearRate">
      <i class="el-icon-circle-close"></i>
    </div>
  </div>
</template>

<script>
import "@/assets/fonts/style.css"
import {
  starColors,
  satisfyColors,
  satisfyIcons
} from "@/components/Sheet/SheetForm/FormItem/static"
export default {
  name: "rate",
  props: {
    value: Number,
    control: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      starColors,
      satisfyColors,
      satisfyIcons
    }
  },
  computed: {
    unit() {
      return this.control.optionStyle === "星星" ? "级" : "分"
    },
    rateTextClass() {
      let result = ""
      if (this.control._type === "rate") {
        if (this.control.level === 5) {
          result = this.getRateTextClass(2, 4)
        }
        if (this.control.level === 10) {
          result = this.getRateTextClass(5, 6)
        }
      }
      return result
    }
  },
  methods: {
    getRateTextClass(min, max) {
      return this.control.optionStyle === "星星"
        ? this.value
          ? "star-text"
          : "no-star"
        : this.value > max
        ? "satisfy-top"
        : this.value > min
        ? "satisfy-medium"
        : "satisfy-bottom"
    },
    emitVal(val) {
      this.$emit("output", val)
    },
    clearRate() {
      this.$emit("output", null)
    }
  }
}
</script>
<style lang="scss" scoped>
.rate {
  display: flex;
  align-items: center;
  &:hover {
    .clear {
      visibility: visible;
    }
  }
  .satisfy {
    ::v-deep {
      .el-rate__item {
        margin-left: 1px;
        margin-right: 2px;
      }
      .el-rate__icon {
        font-size: 15px;
      }
    }
  }
  .level-5 {
    display: flex;
    align-items: center;
  }
  .level-10 {
    display: flex;
    flex-wrap: wrap;
    height: 36px;
    width: 123px;
    min-width: 123px;
  }
  .rate-text {
    margin-left: 5px;
    width: 40px;
  }
  .clear {
    visibility: hidden;
    margin-left: 10px;
    color: #c0c4cc;
    cursor: pointer;
  }
  .no-star {
    color: #99a9bf;
  }
  .star-text {
    color: #ff7373;
  }
  .satisfy-top {
    color: #ff9900;
  }
  .satisfy-medium {
    color: #f7ba2a;
  }
  .satisfy-bottom {
    color: #99a9bf;
  }
}
</style>
